<template>
    <div class="notice02">
      <Nav :navSelectParent="1" />
    <div class='middle02'>
     <img :src="gxbg" alt="" class='gxbg'>
     <img :src="gxtitle" alt="" class='gxtitle'>
     <img :src="bgdi" alt="" class='bgdi'>
     <div class='feiji'>
         <h1 style='font-size:36px;color:#fff;margin-bottom:40px; text-align:center' class='biaot'>【光之圣境基本玩法】公会篇</h1>
         <div class='dise'>
             <p>公会是当今游戏中必不可少的一个内容，它可以让兴趣相同的玩家更好地在一起玩耍。</p>
             <p>在光之圣境中公会玩法更加丰富，主要是福利多多。下面来介绍一下公会玩法。点击【主城】即可看到公会。</p>
             <p>【公会说明】</p>
             <p>人员组成：1名会长、2名副会长、4名官员、8名精英和普通成员;公会成员完成日常任务及公会活动可以获得 活跃值，贡献值和建设值;</p>
             <p>活跃值作用：参与公会基金分红;</p>
             <p>贡献值作用：学习工会技能;</p>
             <p>建设值作用：公会升级。</p>
             <p>【公会福利介绍】</p>
             <p>职位福利：依据活跃度和职位发奖励;</p>
             <p>公会援助：可以选择2种（四系）碎片进行求援，受到玩家帮助可以获得该碎片（单个求援最多领15个）,每人每天免费援助5次（人越多越好呀~）;</p>
             <p>公会祈福：祈福分三种建议中级祈福（100钻石）获得的活跃值和贡献值都有用哦；</p>
             <p>公会求助：过不去命运之塔和英雄传记怎么办？叫大佬呀！助人为乐，快乐之本。你过关了，大佬也有奖励。所以尽情的求助吧；</p>
             <p>公会拍卖：伙伴碎片，升星石。并且记录到公会基金中。还能领分红呦；</p>
             <p>公会红包：大佬们充值之后（单笔30元以上）发到公会中，我们就可以抢了!（论加个好工会的重要性，红包钻石随机的，运气好有大红包！~）；</p>
             <p>公会许愿：消耗许愿币可获得许愿的秘法（秘法篇会详细介绍）；</p>
             <p>公会试炼：就是打工会BOSS，每周期25只BOSS。工会打的越多当天工会拍卖物品就会越多。如果没打死工会商店就没有东西。</p>
             <p>工会技能：升级技能需要消耗贡献点和金币。可获得各种加成。工会越高上限越高。加油吧！</p>
         </div>
     </div>
    </div>
     <div class='gankebottom'>
      <div class='ganke'><img :src="ganke" alt=""></div>
      <div class='btnContent'>
        <div><p>未成年人家长监护工程&nbsp;&nbsp;</p><P>网络游戏出版物号（ISBN）ISBN 978-7-498-07262-7</P></div>
          <div><p>审批文号：国新出审[2020]174 号&nbsp;&nbsp;</p><a href='screct.html'>隐私协议 |&nbsp;&nbsp;</a><a href='https://sdk.djsh5.com/h5game/user/agreement.html'>用户协议 |&nbsp;&nbsp;</a><a href="https://sdk.djsh5.com/h5game/user/antiaddiction.html">防沉迷系统&nbsp;&nbsp;</a><P>来文文号：津新出字[2019]232 号</P></div>
          <div><p>地址：上海市徐汇区虹漕路88号越虹广场B座6楼&nbsp;&nbsp;</p><p>电话：021-64660150&nbsp;&nbsp;</p><P>Email：bd@gank-studio.com</P></div>
          <div><p>抵制不良游戏，拒绝盗z版游戏。 注意自我保护，谨防受骗上当。 适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。</p></div>
      </div>
    </div>
    </div>
  </template>
<script>
import Nav from '../components/nav.vue'
export default {
  name: 'notice02',
  components: {
    Nav
  },
  data () {
    return {
      ganke: require('../assets/ganke.png'),
      imgUrl: require('../assets/nav.png'),
      leftIcon: require('../assets/icon.png'),
      shouter: require('../assets/shouted.png'),
      introduction: require('../assets/introduction.png'),
      characteristic: require('../assets/characteristic.png'),
      gxbg: require('../assets/gxbg.png'),
      gxtitle: require('../assets/gxtitle.png'),
      bgdi: require('../assets/bgdi.png')
    }
  }
}
</script>

<style scoped>
.imgUrl {
  position:absolute;
  width:100%;
  height:88px;
  line-height:88px;
}
.row {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  height:88px;
  padding:0 10%;
  box-sizing: content-box;
}
.iconUl {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  box-sizing: content-box;
}
ul li {
  list-style: none;
}
.middle02 {
  position:relative;
}
.gxbg {
  position:relative;
  width:100vw;
}
.gxtitle {
    position:absolute;
    top:40%;
    left:50%;
    margin-left:-580px;
}
.bgdi {
    position:absolute;
    top:55%;
    left:50%;
    margin-left:-668px;
    width:71%;
    height:750px;
}
.feiji {
    position:absolute;
    top:60%;
    width:60%;
    left:20%;
}
.dise {
    width:100%;
     max-height:350px;
    overflow:scroll;
    background-color:#eee9e0;
    font-size:22px;
    color:#000;
    padding:30px 0
}
.dise p {
    display:block;
    line-height:42px;
    padding:0 25px;

}
.gankebottom {
  width:100vw;
  padding:50px 0;
  background-color:#000;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color:#fff;
  margin-top:-15px;
}
.btnContent {
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size:18px;
}
.btnContent div {
  display:flex;
  flex-direction: row;
}
.btnContent a {
  color: rgb(250, 171, 25);
  cursor: pointer;
}
.ganke {
  margin-right:30px
}
.ganke img{
  width:152px;
  height:60px;
}
@media screen and (max-width: 1300px) {
  .bgdi {
    position: absolute;
    top: 55%;
    width: 80%;
    left: 63% !important;
    height: 525px !important;
}
.feiji {
  top:58%
}
.dise {
  height:350px;
  font-size:20px;
}
.biaot {
  font-size:30px !important;
  margin-bottom:10px !important
}
.gxtitle{
    position: absolute;
    top: 44%;
    left: 25%;
    width: 50%;
    margin-left:0
}
}
</style>



// WEBPACK FOOTER //
// src/pages/notice02.vue